module.exports = __webpack_public_path__ + "img/body-2-lg.3440b4e7.png";